import classNames from "classnames";
import { Field, Form, Formik } from "formik";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BUTTON_TEXT, EMPTY_STRING } from "../../../../constants";
import {
  fetchOrganizations,
  selectOrganizationsFilters,
  selectSelectedOrganization,
  selectSelectedOrganizationId,
  updateOrganization,
} from "../../../../pages/Organizations";
import Drawer, { selectSelectedDrawer } from "../../../organisms/Drawer";
import { actions } from "../../../organisms/Drawer/drawers.reducers";

const { SUBMIT } = BUTTON_TEXT;
const { setSelectedDrawer } = actions;

const ManageOrganizationDrawer = () => {
  const dispatch = useDispatch();
  const selectedDrawer = useSelector(selectSelectedDrawer);
  const organizationId = useSelector(selectSelectedOrganizationId);
  const selectedOrganization = useSelector(selectSelectedOrganization);
  const organizationFilters = useSelector(selectOrganizationsFilters);
  const [initialValues, setInitialValues] = useState({
    name: EMPTY_STRING,
  });

  useEffect(() => {
    if (selectedOrganization)
      setInitialValues({ name: selectedOrganization.name });
  }, [selectedOrganization]);

  const handleClose = useCallback(
    (resetForm) => {
      dispatch(setSelectedDrawer(null));
      resetForm();
    },
    [dispatch]
  );

  const handleOnSubmit = useCallback(
    (values, { resetForm }) => {
      dispatch(updateOrganization({ id: organizationId, data: values })).then(
        (res) => {
          if (res.payload) {
            dispatch(setSelectedDrawer(null));
            dispatch(fetchOrganizations(organizationFilters));
            resetForm();
          }
        }
      );
    },
    [dispatch, organizationId, organizationFilters]
  );

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleOnSubmit}
      validateOnMount={true}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        resetForm,
      }) => {
        const footer = (
          <div className="p-6 border-t border-gray-700 flex align-center justify-end">
            <button
              className="btn btn-primary-light mr-1"
              type="button"
              onClick={() => handleClose(resetForm)}
            >
              Cancel
            </button>
            <button className="btn btn-primary" type={SUBMIT}>
              {SUBMIT}
            </button>
          </div>
        );
        return (
          <Form onSubmit={handleSubmit}>
            <Drawer
              position="right"
              heading="Create Organization"
              subHeading="Configure your organization settings."
              handleClose={() => handleClose(resetForm)}
              selectedDrawer={selectedDrawer}
              footer={footer}
            >
              <div className="scrollbar flex-1 overflow-auto">
                <div className="space-y-4 p-6 border-b border-gray-700">
                  <div className="form-group">
                    <label className="text-sm font-medium text-gray-50 mb-1 block">
                      Organization Name
                    </label>
                    <Field
                      name="name"
                      type="text"
                      className={classNames("form-control border-2", {
                        "border-red-600": touched.name && errors.name,
                      })}
                      placeholder="Organization Name"
                      value={values.name}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                    {touched.name && errors.name && (
                      <div className="text-sm font-medium text-red-500">
                        {errors.name}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Drawer>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ManageOrganizationDrawer;
